import { createAction, handleActions } from 'redux-actions';

const setSearchTerm = createAction('SCREENS/SUBBIES/SUBCONTRACTORS/SET_SEARCH_TERM');
const clearSearchTerm = createAction('SCREENS/SUBBIES/SUBCONTRACTORS/CLEAR_SEARCH_TERM');

const defaultState = '';

const reducer = handleActions(
  {
    [setSearchTerm]: (state, action) => action.payload,
    [clearSearchTerm]: () => ''
  },
  defaultState
);

export { setSearchTerm, clearSearchTerm, reducer };
